<div class="cartLine" [class.emphasis]="emphasis" [class.success]="tone === 'success'" [class.primary]="tone === 'primary'" [class.medium]="tone === 'medium'">
  @if (marker) {
    <span class="cartLineMarker" aria-hidden="true"></span>
  }
  <div class="cartLineBody">
    <div class="cartLineHeading">
      <span class="cartLineLabel"><ng-content select="[lineLabel]"></ng-content></span>
      <span class="cartLineTag"><ng-content select="[lineTag]"></ng-content></span>
    </div>
    <div class="cartLineDetails"><ng-content></ng-content></div>
    <div class="cartLineNotes"><ng-content select="[lineNote]"></ng-content></div>
  </div>
  @if (amount !== null) {
    <div class="cartLineAmount">
      <span class="cartLineValue">{{ sign }}{{ amount | number:'1.2-2' }}€</span>
      @if (quantity > 1 && unitPrice !== null) {
        <span class="cartLineUnit">{{ quantity }} × {{ unitPrice | number:'1.2-2' }}€</span>
      }
    </div>
  }
</div>
